import moment from 'moment';

// >>>>>> CONSTANTS <<<<<<<<
export const PRESET_PROJECTION_RANGES = [
  { text: 'Daily', numDays: 1 },
  { text: 'Weekly', numDays: 7 },
  { text: 'Monthly', numDays: 30 },
  { text: 'Quarterly', numDays: 90 },
];

// >>>>>> DATES <<<<<<<<<
export const today = moment.utc().utcOffset(-5).format('YYYY-MM-DD');
export const tomorrow = moment.utc().utcOffset(-5).add(1, 'days').format('YYYY-MM-DD');
export const weekFromToday = moment.utc().utcOffset(-5).add(7, 'days').format('YYYY-MM-DD');
export const monthFromToday = moment.utc().utcOffset(-5).add(31, 'days').format('YYYY-MM-DD');
export const quarterFromToday = moment.utc().utcOffset(-5).add(90, 'days').format('YYYY-MM-DD');

// // >>>>>>> REFORMAT <<<<<<<<<<
export const reformatDateMMDDYYYY = date => moment(date, 'YYYY-MM-DD').format('MM/DD/YYYY');
export const reformatDateYYYYMMDD = date => moment(date, 'MM/DD/YYYY').format('YYYY-MM-DD');

// >>>>>>> HELPERS <<<<<<<<<
export const isAfterTomorrow = date => moment(date).isAfter(today);
export const daysAfter = num => moment.utc().utcOffset(-5).add(num + 1, 'days').format('YYYY-MM-DD');
export const calculateDifferenceInDays = (startDate, endDate) => {
  const start = moment(startDate);
  const end = moment(endDate);
  return end.diff(start, 'days');
};
export const numDaysLater = (startDate = tomorrow, endDate = monthFromToday, preset = false) => {
  const diff = calculateDifferenceInDays(startDate, endDate);
  const preset_ranges = [1, 7, 14, 21, 30, 90];

  if (preset) {
    if (startDate === tomorrow && preset_ranges.includes(diff)) return diff;
    if (endDate !== tomorrow || preset_ranges.includes(diff)) return 'custom';
  }
  return diff;
};
export const getPeriodName = (numDays, startDate, endDate) => {
  const isStartDateTomorrow = startDate === tomorrow;
  if (isStartDateTomorrow && numDays === 1) return 'Daily';
  if (isStartDateTomorrow && numDays === 7) return 'Weekly';
  if (isStartDateTomorrow && numDays === 30) return 'Monthly';
  if (isStartDateTomorrow && numDays === 90) return 'Quarterly';
  return `${reformatDateMMDDYYYY(startDate)} to ${reformatDateMMDDYYYY(endDate)}`;
};
export const dateIsBetween = (date, startDate, endDate) => moment(date).isBetween(moment(startDate), moment(endDate), undefined, '[]');
export const isDateRangeWithin = (selectedRange, definedRange) => {
  const selectedStart = moment(selectedRange[0]);
  const selectedEnd = moment(selectedRange[1]);
  const definedStart = moment(definedRange[0]);
  const definedEnd = moment(definedRange[1]);

  return selectedStart.isSameOrAfter(definedStart) && selectedEnd.isSameOrBefore(definedEnd);
};
export const checkStorageDateIsValid = (dateRangeValue, dateRange) => {
  if (dateRange) {
    return isDateRangeWithin(dateRangeValue.split(' - '), dateRange);
  }
  return isAfterTomorrow(dateRangeValue.split(' - ')[0]);
};

export const getNextDay = dateString => moment(dateString).add(1, 'days').format('YYYY-MM-DD');

/**
 * Shifts a date to the previous year if it falls after the reference date.
 * Useful for year-over-year date alignment when comparing historical data.
 *
 * @param {string} date - The date to adjust in 'YYYY-MM-DD' format
 * @param {string} referenceDate - The reference date to compare against in 'YYYY-MM-DD' format
 * @returns {string} The adjusted date in 'YYYY-MM-DD' format, shifted back one year if necessary
 */
export const alignDateToPreviousYear = (date, referenceDate) => {
  const targetDate = moment(date);

  if (targetDate.isAfter(referenceDate)) {
    return targetDate.year(moment(referenceDate).year() - 1).format('YYYY-MM-DD');
  }

  return targetDate.format('YYYY-MM-DD');
};
